require('./mortgageRequestSimpleNoteSuccessfulResult.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');

// @ commons
const { formatText } = require('core/i18n').i18n;


// @ components
const { OKButton } = require('components/commons/OKButton/OKButton');
const { ContentBox } = require('commonsComponents/contentBox');
const MortgageRequestSimpleNoteSuccessful = require('./mortgageRequestSimpleNoteSuccessful');
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');

class MortgageRequestSimpleNoteSuccessfulResult extends React.Component {
    constructor(props) {
        super(props);

        this.handleBackButtonClick = this.handleBackButtonClick.bind(this);
    }

    handleBackButtonClick() {
        this.props.requestState('/myprofile/mortgage/panel', this.props.history)
    }

    render() {
        return (
            <div className="mortgage-request-simple-note-result-successful">
                <ContentBox customClassName="mortgage-request-simple-note-result-successful__content">
                    <WizardSuccess successMessage={formatText('mortgageRequestSimpleNoteSuccessfulResult-mainTitle')}>
                        <MortgageRequestSimpleNoteSuccessful />
                    </WizardSuccess>
                    <div className="row">
                        <div className="col-md-10 col-md-offset-2"><hr /></div>
                        <div className="col-md-4 col-md-offset-2">
                            <OKButton
                                id="lnk_wizardSuccessStep_mainButton"
                                modifier="link-complementary"
                                onClick={this.handleBackButtonClick}
                            >
                                {formatText('mortgageRequestSimpleNoteSuccessfulResult-backToPanelText')}
                            </OKButton>
                        </div>
                    </div>
                </ContentBox>
            </div>
        );

    }
}

MortgageRequestSimpleNoteSuccessfulResult.propTypes = {
    requestState: PropTypes.func,
    history: PropTypes.object.isRequired,
};

module.exports.constructor = MortgageRequestSimpleNoteSuccessfulResult;

module.exports = withRouter(MortgageRequestSimpleNoteSuccessfulResult);
